<template>
  <div class="router-wrapper">
    <div class="element-wrapper">
      <div class="os-tabs-w">
        <div class="os-tabs-controls os-tabs-complex">
          <div class="nav-item">
            <h1>{{ $t("products_create.heading") }}</h1>
          </div>
          <div class="nav-item">
            <button type="button" class="button" color="primary" size="xlarge" v-on:click="send">
              {{ $t("general.save") }}
            </button>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="element-box">
          <form>
            <h5 class="form-header">{{ $t("products_create.heading") }}:</h5>

            <product-properties :product="product" />
            <div class="row">
              <div class="col-lg-12">
                <button type="button" color="primary" class="button" size="max" v-on:click="send">
                  {{ $t("general.save") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from "@/models/Product";
import { mapState, mapActions } from "vuex";
import { ProductInfoProperties } from "@/models/graphql-global-types";
import ProductProperties from "@/components/products/partials/edit/product-properites";

export default {
  name: "ProductsCreate",
  components: {
    "product-properties": ProductProperties
  },
  data() {
    return {
      product: new Product(),
      isProductValid: {}
    };
  },
  methods: {
    ...mapActions("productStore", ["save"]),
    send() {
      if (this.product.isValid) {
        const properties = this.product.properties;
        const dropdownProperties = [];
        const textProperties = [];
        this.productInfo.fields.forEach(field => {
          const property = properties[field.id];

          if (property === undefined) {
            return;
          }

          if (field.isDropdown) {
            const p = {
              property: field.id,
              values: []
            };

            if (field.allowsMultiple) {
              p.values = property.map(value => {
                return { id: value.id };
              });
            } else if (field.hasCustomValues) {
              p.values.push({ customValue: property.name });
            } else {
              p.values.push({ id: property.id });
            }

            dropdownProperties.push(p);
          } else {
            textProperties.push({ property: field.id, value: property });
          }
        });

        const input = {
          textProperties: textProperties,
          dropdownProperties: dropdownProperties
        };

        this.save(input)
          .then(r => {
            this.$router.push("/products");
          })
          .catch(e => alert(e));
      }
    }
  },
  computed: {
    ...mapState("productStore", ["productInfo"])
  }
};
</script>

<style scoped lang="scss"></style>
